/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as const
};

export const NOT_SHOW_SNACKBAR = {
  showSnackbar: false
}
